import React from 'react'
import PropTypes from 'prop-types'
import {regionPropType} from '@salesforce/commerce-sdk-react/components'
import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * Column1 layout
 * 1 Row, 1 Column, Landscape
 */
export const Column1 = ({regions}) => {
    const styles = useMultiStyleConfig('containerStyles')
    return <Box {...styles.containerStyles}>{regions?.column1 && <regions.column1 />}</Box>
}

Column1.displayName = 'Column1'

Column1.propTypes = {
    regions: PropTypes.shape({
        column1: regionPropType
    }).isRequired
}

export default Column1
